import { Pipe, PipeTransform } from '@angular/core';
import { ActionDef, Actions, ActionType, ofActionCompleted, ofActionDispatched } from '@ngxs/store';
import { Observable, merge } from 'rxjs';
import { delay, filter, map, startWith } from 'rxjs/operators';

type ActionInstance<T extends ActionType> = T extends ActionDef ? InstanceType<T> : T;

@Pipe({
  name: 'actionInProgress',
  pure: true,
  standalone: true,
})
export class ActionInProgressPipe implements PipeTransform {
  constructor(private actions$: Actions) {}

  transform<TActions extends ActionType[]>(
    actionNames: TActions,
    initial = false,
    matchesAction: (action: ActionInstance<NoInfer<TActions[number]>>) => boolean = () => true
  ): Observable<boolean> {
    const dispatchedObservables = this.actions$.pipe(
      ofActionDispatched(...actionNames),
      filter((action) => matchesAction(action as ActionInstance<TActions[number]>)),
      map(() => true)
    );

    const completedObservables = this.actions$.pipe(
      ofActionCompleted(...actionNames),
      filter(({ action }) => matchesAction(action as ActionInstance<TActions[number]>)),
      map(() => false)
    );

    return merge(dispatchedObservables, completedObservables).pipe(startWith(initial), delay(0));
  }
}
